<template>
  <section id="Brands">
    <div id="main">
      <div class="container">
        <div class="content-wrapper text1">
          <h2 v-html="$t('brands.h2')"></h2>
          <p class="mp-4 bor-b"></p>
          <p class="p mt-4" v-html="$t('brands.p')"></p>
        </div>
        <div>

        </div>
        <div class="blog-wrapper ">
          <div class="row ul">
            <div class="col-my-6 col-xs-6 col-sm-6 col-md-3 col-lg-3 li" v-for="(item, index) in colList" :key="index">
              <div class="box" @click="href(item.name, item.img)">
                <img :class="index == 4 ? 'pxy-10' : ''" class="animate__animated animate__fadeIn" :src="item.img" alt="">
                <div class="tent">
                  <strong v-html="item.title"></strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="van-fade">
      <div class="loading" v-if="show_">
        <img width="220px" class="animate__animated animate__fadeIn" :src="brand_img" />
        <!-- <van-loading type="spinner" size="50px" color="#000" /> -->
      </div>
    </transition>
  </section>
</template>

<script>

export default {
  metaInfo: {
    title: 'Brand', // set a title
    meta: [{             // set meta
      name: 'keywords',
      content: 'Brand'
    },
    {
      name: 'description',
      content: 'Brand'
    }]
  },
  name: "Brand",
  inject: ['reload'],
  data() {
    return {
      colList: [],
      show_: false,
      brand_img: ''
    };
  },
  components: {},
  mounted() {
    let that = this
    that.brands()

    PubSub.subscribe('locale', (msg, data) => {
      if (data.locale != '') {
        that.reload()
        that.$validator.locale = that.$store.state.locale
      }
    })
  },
  methods: {
    href(e, img) {
      this.show_ = true
      this.brand_img = img
      // console.log('e', e, '-----------', e.toUpperCase(), e.toLowerCase())
      // this.$router.push('/kia');
      // this.$router.push({ path: `/${e.toLowerCase()}` })
      setTimeout(() => {
        this.$router.push({ name: `${e.toUpperCase()}`, params: { brand: e.toLowerCase() } })
      }, 700)
      //window.open(e, '_blank')
    },
    //替换中英文
    brands() {
      let that = this
      that.colList = that.$t('brands.col')
    },
    // handleClick(e, val) {
    //   val.off = !val.off
    //   // e.currentTarget.firstElementChild.nextElementSibling.addClass="animated bounceOutLeft"
    //   console.log('target', e.target)
    //   console.log('currentTarget', e.currentTarget.firstElementChild.nextElementSibling)
    //   console.log('currentTarget', e.currentTarget.parentElement)
    // }
  },
};
</script>

<style scoped lang="scss">
  /* 全局样式文件（无 scoped） */
  /* 淡入动画时长：0.5s */
  /deep/ .van-fade-enter-active {
    transition: opacity 0.1s ease-in;
  }

  /* 淡出动画时长：0.8s */
  /deep/ .van-fade-leave-active {
    transition: opacity 0.8s ease;
  }

  .loading {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top:0;
    left:0;
    z-index: 1111;
    // top: 50%;
    // left: 50%;
    margin-left: 0;
    margin-top: 0;
    background: #fff;
    display: flex !important;
    justify-content: center;
    align-items: center;
    // opacity: 0;
    // transition: all 0.2s;
    // &.show {
    //   opacity: 1;
    // }
  }
	.p {
    font-size: 16px;	
    line-height: 30px;
    width: 100%;
	}

  /*Brands*/
  #Brands .blog-wrapper .row>div {    
    padding-right: 0;
    padding-left: 0;
  }

  #Brands .blog-wrapper {
    width: 100%;
    margin: 100px 0;
    .ul {
      margin-right: 0;
      margin-left: 0;
      -webkit-box-align: stretch;
      align-items: stretch;
      display: -webkit-box;
      display: flex;
      flex-wrap: wrap;
      -webkit-box-pack: justify;
      justify-content: space-between;
        
      .li {
        padding: 0 6px;
        margin-bottom: 36px;
        &:nth-of-type(n+3) {
          margin-bottom: 0;
        }
        &:hover {
          .box {
            .tent {
              color: #ae0526;
              text-decoration: underline;
            }
            img {
              background: #e5e5e5;
            }
          }
        }
        .box {
          text-align: center;
          cursor: pointer;
          img {
            display: inline-block;
            width: 200px;
            height: 200px;
          }
          .tent {
            margin-top: 6px;
            p {
              margin-top: 12px;
              margin-bottom: 0;
              font-size: 16px;
              line-height: 24px;
            }
            strong {
              font-size: 21px;
              line-height: 30px;
              // color: #333
            }
          }
          img {
            // width: 100%;
          }
        }
      }
    }
  }

  #Brands .blog {
      position: relative;
      background-color: #e5e5e5;
      padding: 10px;
      margin-bottom: 15px;
  }

  #Brands .blog-title {
      overflow: hidden;
      margin-bottom: 10px;
  }

  #Brands .blog-title img {
      float: right;
  }

  #Brands .show-blog {
      position: relative;
      display: block;
      padding-left: 15px;
      width: 80%;
      color: #000;
      font-size: 12pt;
      text-decoration: initial;
      float: left;
  }

  #Brands .show-blog:before {
      display: block;
      content: "";
      width: 10px;
      height: 10px;
      background-image: url(../images/plus_btn.png);
      position: absolute;
      left: 0;
      top: 5px;
  }

  #Brands .active .show-blog:before {
      background-position: 0 -10px;
  }

  #Brands .blog-content {
      // display: none;
  }

  #Brands a.more,
  #search a.more {
      color: #000;
      text-decoration: underline;
  }

  @media (max-width: 1200px) {
    #Brands .blog-wrapper {
      .ul {
        .li {
          .box {
            img {
              width: 180px;
              height: 180px;
            }
            .tent {
              p {
                font-size: 16px;
              }
              strong {
                font-size: 19px;
              }
            }
          }
        }
      }
    }
  }

  @media (max-width:992px) {
    #Brands .blog-wrapper {
      margin: 30px 0;
      .ul {
        .li {
          .box {
            img {
              width: 160px;
              height: 160px;
            }
            .tent {
              p {
                font-size: 16px;
              }
              strong {
                font-size: 18px;
              }
            }
          }
        }
      }
    }
  }

  @media (max-width: 767px) {
    #Brands .blog-wrapper {
      margin: 20px 0 0;
      .ul {
        .li {
          .box {
            img {
              width: 140px;
              height: 140px;
            }
            .tent {
              p {
                font-size: 15px;
              }
              strong {
                font-size: 17px;
              }
            }
          }
        }
      }
    }
  }
  
  @media (max-width: 468px) {
    #Brands .blog-wrapper {
      margin: 20px 0 0;
      .ul {
        .li {
          .box {
            img {
              width: 120px;
              height: 120px;
            }
            .tent {
              p {
                font-size: 14px;
              }
              strong {
                font-size: 15px;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Brands.vue